import { PcrPayment } from '../../lib/types/models/pcr/pcr'
import { PcrPaymentInput } from '../../lib/types/models/pcr/pcr-input'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const getPcrPayments = (id: number, input: PcrPaymentInput) => {
  return restApiClient
    .url(encodeNestedObject<PcrPaymentInput>(constructApiUrl(API.pcr.payments.url, { id }), input))
    .get<PcrPayment[]>()
}
